import { Subject } from 'rxjs';
import { Globals } from '../objects/Globals';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EnvService } from '../env.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../objects/Globals";
import * as i3 from "../env.service";
var ChartService = /** @class */ (function () {
    function ChartService(http, globals, env) {
        this.http = http;
        this.globals = globals;
        this.env = env;
        this.chartRefresh = new Subject();
        this.chartRefreshChanged$ = this.chartRefresh.asObservable();
        this.loginUrl = this.env.servicePath;
        this.serviceUrl = this.env.servicePath;
    }
    ChartService.prototype.setChartRefresh = function (refresh) {
        this.chartRefresh.next(refresh);
    };
    ChartService.prototype.getPinnedCharts = function () {
        var path = this.serviceUrl + "CreateChartCard/PinnedCharts";
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, '', httpOptions);
    };
    ChartService.prototype.getChart = function (id) {
        var path = this.serviceUrl + "GetChartCard/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    ChartService.prototype.nextChart = function (id) {
        var path = this.serviceUrl + "NextChart/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, '', httpOptions);
    };
    ChartService.prototype.previousChart = function (id) {
        var path = this.serviceUrl + "PreviousChart/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, '', httpOptions);
    };
    ChartService.prototype.getChartData = function (id, filterSeries, filterSelection) {
        var path = this.serviceUrl + "GetChartData/" + id + "/" + filterSeries + "?selection=" + filterSelection;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, '', httpOptions);
    };
    ChartService.prototype.getFullChartData = function (id) {
        var path = this.serviceUrl + "GetFullChartData/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    ChartService.prototype.expandChart = function (id) {
        var path = this.serviceUrl + "ExpandChart/" + id;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, '', httpOptions);
    };
    ChartService.ngInjectableDef = i0.defineInjectable({ factory: function ChartService_Factory() { return new ChartService(i0.inject(i1.HttpClient), i0.inject(i2.Globals), i0.inject(i3.EnvService)); }, token: ChartService, providedIn: "root" });
    return ChartService;
}());
export { ChartService };
